import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import menuHelper from "../../../util/menu-helper";

@Component({
    name: "leftmenu-item",
})
export default class LeftMenuItem extends Vue {
    @Prop({ type: Object }) item!: appbase.cache.TMenuItem;
    @Prop({ type: Array }) menuPermission!: account.TPermissionMenu[];
    @Prop({ type: Array }) menuItemPath!: number[];
    @Prop({ type: String }) userLang!: string;
    @Prop({ type: Object }) menuItem: appbase.cache.TMenuItem | null = null;
    @Prop({ type: Array, default: () => [] }) isNewArticle!: number[];

    expandCustomFlag: boolean = false;
    expandFlagChange: boolean = false;
    expandbuttonChange: boolean = false;
    get selected() {
        var menuId = Number(this.$route.query.MENUID);
        return menuId === this.item.menuId;
    }

    get expandflag() {
        if (this.menuItemPath.includes(this.item.menuId)) {
            this.expandFlagChange = true;
            this.expandbuttonChange = true;
            return true;
        } else if (this.menuItemPath[1] == this.item.parentMenuId) {
            this.expandFlagChange = true;
            this.expandbuttonChange = true;
            return true;
        } else if (this.item.hasChildren == false) {
            this.expandFlagChange = true;
            this.expandbuttonChange = true;
            return true;
        } else if (this.menuItemPath[1] == menuHelper.getSubMenuId(this.item.menuId)) {
            this.expandFlagChange = true;
            this.expandbuttonChange = true;
            return true;
        } else {
            this.expandFlagChange = false;
            this.expandbuttonChange = true;
            return false;
        }
    }

    get isPermission() {
        let isPermission: boolean = false;
        if (this.menuPermission && this.menuPermission.find((x) => x.id == this.item.menuId)) isPermission = true;
        return isPermission;
    }

    get customClass() {
        if (this.item.customClass) {
            return this.item.customClass;
        }
        return "";
    }

    /** 2024-09-12 이수 게시판 개선요청 - 신규 게시글이 등록 된 게시판에 N 아이콘 표시*/
    @Watch("isNewArticle", { immediate: true })
    isShowNewIcon() {
        if (this.item && this.isNewArticle.length > 0 && location.href.indexOf("board/list") != -1) {
            this.updateIsNewIcon(this.item);
        }
    }

    updateIsNewIcon(item: any) {
        if (item.systemId && this.isNewArticle.includes(item.systemId)) {
            this.$set(item, "isNewIcon", true);
        } else {
            this.$set(item, "isNewIcon", false);
        }

        // 자식 항목이 있는 경우 재귀적으로 호출
        if (item.children && item.children.length > 0) {
            item.children.forEach((child: any) => this.updateIsNewIcon(child));
        }
    }

    mounted() {
        var menuId = Number(this.$route.query.MENUID);
        if (menuId == this.item.menuId) {
            // 현재 메뉴 위치로 Scroll을 이동한다.
            this.$el.scrollIntoView();
        }
    }
}
